import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Department } from '../models';

@Injectable()
export abstract class DepartmentsService {
    abstract createDepartment(name: string, phone: string): Promise<void>;

    abstract deleteDepartment(departmentId: string): Promise<void>;

    abstract department(departmentId: string): Promise<Department | undefined>;

    abstract departments(): Observable<Department[]>;

    abstract updateDepartment(departmentId: string, data: { name?: string, phone?: string }): Promise<void>;
}
